/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import { Box } from "@material-ui/core";

import type { FC } from "react";

export const PurchasingModal: FC = () => {
  return (
    <Box
      position={"absolute"}
      top={0}
      bottom={0}
      left={0}
      right={0}
      zIndex={"10000"} // 動画プレイヤーより上
    >
      {/* 画面全体を覆う背景 */}
      <Box
        position={"fixed"}
        top={0}
        left={0}
        width={"100%"}
        height={"100%"}
        bgcolor={"rgba(0, 0, 0, 0.16)"}
      />
      <Box
        position={"relative"}
        top={"50%"}
        left={"50%"}
        width={"90%"}
        padding={"16px"}
        textAlign={"center"}
        bgcolor={"#fff"}
        borderRadius={"16px"}
        css={css`
          transform: translate(-50%, -50%);
        `}
      >
        <Box marginBottom={"8px"} fontSize={"16px"} fontWeight={"700"}>
          <Box>購入中です</Box>
          <Box>そのままお待ちください</Box>
        </Box>

        <Box component={"p"} fontSize={"14px"} lineHeight={"1.5em"}>
          画面を移動すると決済が正しく行われない可能性があるため、操作しないでください。
        </Box>
      </Box>
    </Box>
  );
};
